export default __webpack_public_path__ + "static/img-nhs-app-cab1ea597a8f9901a37da60f2a6bc0ae.webp";